import React from 'react';
import { i18n } from 'config/locales';
import { Summary, DateSummary } from 'components/Summary';

import { LEGAL, LEGAL_ASSOCIATIONS_HATE_CRIME_ADVOCACY } from 'config/formSections/legal';
import Subsection from 'components/Section/shared/Subsection';
import connectSubsection from 'components/Section/shared/SubsectionConnector';
import { EmptyListInstance } from 'forms/shared/models';
import Branch from 'components/Form/Branch';
import Show from 'components/Form/Show';
import Accordion from 'components/Form/Accordion';
import EventItem from './EventItem';

const sectionConfig = {
  key: LEGAL_ASSOCIATIONS_HATE_CRIME_ADVOCACY.key,
  section: LEGAL.name,
  store: LEGAL.store,
  subsection: LEGAL_ASSOCIATIONS_HATE_CRIME_ADVOCACY.name,
  storeKey: LEGAL_ASSOCIATIONS_HATE_CRIME_ADVOCACY.storeKey,
};

export class HateCrimeAdvocacy extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
    this.handleError = this.handleError.bind(this);
  }

  update = (queue) => {
    this.props.onUpdate(this.storeKey, {
      List: this.props.List,
      HasHateCrimeAdvocacy: this.props.HasHateCrimeAdvocacy,
      ...queue,
    });
  };

  updateList = (values) => {
    this.update({
      List: values,
    });
  };

  updateBranch = (values) => {
    this.update({
      HasHateCrimeAdvocacy: values,
      List: values.value === 'Yes' ? this.props.List : [],
    });
  };

  render() {
    const { errors } = this.props;

    const subSectionName = 'hateCrimeAdvocacy';
    const sectionAssetPath = 'legal.pvq.associations';
    const subSectionAssetPath = `${sectionAssetPath}.${subSectionName}`;
    const subSectionClassName = subSectionAssetPath.replaceAll('.', '-');

    const accordionErrors = errors && errors.filter((e) => e.indexOf('List.accordion') === 0);

    const summary = (item, index) => {
      const o = (item && item.Item) || {};
      const dates = DateSummary(o.When);
      const details = (o.Reasons || {}).value || '';

      return Summary({
        type: i18n.t(`${subSectionAssetPath}.collection.item`),
        index,
        left: details,
        right: dates,
        placeholder: i18n.t(`${subSectionAssetPath}.collection.unknown`),
      });
    };

    return (
      <div
        className={`section-content ${subSectionClassName}`}
        data-section={LEGAL.key}
        data-subsection={LEGAL_ASSOCIATIONS_HATE_CRIME_ADVOCACY.key}
      >
        <h1 className="section-header">
          {i18n.t(`legal.pvq.subsection.associations.${subSectionName}`)}
        </h1>
        <Branch
          name="HasHateCrimeAdvocacy"
          label={i18n.t(`${subSectionAssetPath}.hasHateCrimeAdvocacy`)}
          labelSize="h4"
          className={`${subSectionClassName}-hasHateCrimeAdvocacy`}
          {...this.props.HasHateCrimeAdvocacy}
          warning
          onError={this.handleError}
          required={this.props.required}
          onUpdate={this.updateBranch}
          scrollIntoView={this.props.scrollIntoView}
          attribute="HasHateCrimeAdvocacy"
        />

        <Show when={this.props.HasHateCrimeAdvocacy.value === 'Yes'}>
          <Accordion
            defaultState={this.props.defaultState}
            {...this.props.List}
            scrollToBottom={this.props.scrollToBottom}
            summary={summary}
            onUpdate={this.updateList}
            onError={this.handleError}
            errors={accordionErrors}
            description={i18n.t(`${subSectionAssetPath}.collection.description`)}
            appendTitle={i18n.t(`${subSectionAssetPath}.collection.appendTitle`)}
            appendLabel={i18n.t(`${subSectionAssetPath}.collection.appendLabel`)}
            required={this.props.required}
            attribute="List"
            scrollIntoView={this.props.scrollIntoView}
          >
            <EventItem
              name="Item"
              attribute="List"
              bind
              required={this.props.required}
              scrollIntoView={this.props.scrollIntoView}
              subSectionAssetPath={subSectionAssetPath}
              subSectionClassName={subSectionClassName}
              hasWhy
              hasWhen
              hasWhat
            />
          </Accordion>
        </Show>
      </div>
    );
  }
}

HateCrimeAdvocacy.defaultProps = {
  name: 'hateCrimeAdvocacy',
  HasHateCrimeAdvocacy: {},
  List: EmptyListInstance,
  defaultState: true,
  onUpdate: () => { },
  onError: (value, arr) => arr,
  section: 'legal',
  subsection: 'associations/hate-crime-advocacy',
  dispatch: () => { },
  scrollToBottom: '',
  errors: [],
};

export default connectSubsection(HateCrimeAdvocacy, sectionConfig);
